import Header from "./Header";
import Hero from "./Hero";
import Apoio from "./Apoio"
import Sobre from './Sobre'
import Funciona from "./Funciona";
import Objetivos from './Objetivos'
import Newsletter from './Newsletter'
import Contato from './Contato'
import Footer from "./Footer";
import Rooms from "./Rooms";
import Self from "./Self";
import Login from "./Login";
import ProntuarioList from "./ProntuarioList";
import ProntuarioForm from "./ProntuarioForm";
import ProntuarioDetail from "./ProntuarioDetail";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
  return (
    <Router>
    <div className="App">
      <Header />
      <Routes>
        <Route path='/' element={<Main />}/>
        <Route path='/salas' element={<Rooms />}/>
        <Route path='/autoavaliacao' element={<Self />} />
        <Route path='/login' element={<Login />} />
        <Route path="/prontuarios" element={<ProntuarioList />} />
        <Route path="/criar-prontuario" element={<ProntuarioForm />} />
        <Route path="/prontuarios/:id" element={<ProntuarioDetail />} />
      </Routes>
      <Footer />
    </div>
    </Router>
  );
}

const Main = () => {
  return (
    <div className="App">
        <Hero/> 
        {/* <Parceiros /> */}
        <Apoio /> 
        <Sobre /> 
        <Funciona /> 
        <Objetivos /> 
        <Newsletter />
        <Contato />
    </div>
  )
}

export default App;
